import { render, staticRenderFns } from "./userSettingsComponent.vue?vue&type=template&id=68b7e1d1&"
import script from "./userSettingsComponent.vue?vue&type=script&lang=js&"
export * from "./userSettingsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports